var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideDeviceViewIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_4539)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#152D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.821 27.9133L17.1514 22.2437C17.0362 22.1285 16.9535 22.0066 16.9033 21.8779C16.8532 21.7492 16.8281 21.6118 16.8281 21.4659C16.8281 21.32 16.8532 21.1827 16.9033 21.054C16.9535 20.9253 17.0362 20.8033 17.1514 20.6882L22.8405 14.999C23.056 14.7835 23.3185 14.6758 23.6281 14.6758C23.9376 14.6758 24.2001 14.7835 24.4156 14.999C24.6311 15.2145 24.7356 15.4802 24.729 15.7963C24.7225 16.1124 24.6115 16.3781 24.396 16.5936L19.5237 21.4659L24.4156 26.3578C24.6311 26.5733 24.7388 26.8325 24.7388 27.1356C24.7388 27.4386 24.6311 27.6979 24.4156 27.9133C24.2001 28.1288 23.9343 28.2365 23.6183 28.2365C23.3022 28.2365 23.0364 28.1288 22.821 27.9133Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.516167,
    y: 0.516167,
    width: 41.9677,
    height: 41.9677,
    rx: 20.9838,
    stroke: "white",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_4539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideDeviceViewIconNew);
export default __webpack_public_path__ + "static/media/hideDeviceViewIconNew.43706cda.svg";
export { ForwardRef as ReactComponent };